import { camelize } from 'helpers/syntaxHelper';

const camelizeFilterField = (filter: SentenceFilterT) => ({
    ...filter,
    field: camelize(filter.field),
});

/** Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Camelize 'field' into a body containing one data Filter.
 * @param body : a body containing a unique filter.
 * @returns : the body with camelized 'field'
 */
export const filterPostProcessingMiddleware = (body: {
    data: SentenceFilterT;
}) => ({ data: camelizeFilterField(body.data) });

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with global_filters fetch body, by camelizing field values
 * into payload.data.
 */
export const globalFiltersPostProcessingMiddleware = (body: {
    data: { field: string }[];
}) => {
    const postProcessedData = body.data.map(camelizeFilterField);
    return {
        ...body,
        data: postProcessedData,
    };
};

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with filters fetched through the budget_proposal/get_data endpoint
 */
export const filtersPostProcessingMiddleware = (body: {
    data: {
        filters: {
            field: string;
        }[];
    };
}) => {
    const postProcessedData = {
        ...body.data,
        filters: body.data.filters.map((filter: { field: string }) => ({
            ...filter,
            field: camelize(filter.field),
        })),
    };
    return { data: postProcessedData };
};
